

import { useState } from "react";
import { Search, Filter } from "lucide-react";

interface RoomFiltersProps {
  search: string;
  setSearch: (value: string) => void;
  statusFilter: string;
  setStatusFilter: (value: string) => void;
  typeFilter: string;
  setTypeFilter: (value: string) => void;
  onApply: () => void;
}

const roomTypes = ['Banquet', 'Open Air', 'Conference', 'Accommodation'];

export function RoomFilters({
  search,
  setSearch,
  statusFilter,
  setStatusFilter,
  typeFilter,
  setTypeFilter,
  onApply,
}: RoomFiltersProps) {
  const [showFilters, setShowFilters] = useState(true);
  const hasActiveFilters = statusFilter || typeFilter;

  return (
    <div className="bg-white rounded-xl border border-stone-200 p-4">
      {/* Mobile filter toggle */}
      <div className="md:hidden flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Filter className="w-4 h-4 text-stone-500" />
          <span className="text-sm font-medium text-stone-700">
            {hasActiveFilters ? 'Filters active' : 'Filters'}
          </span>
          {hasActiveFilters && (
            <span className="w-2 h-2 bg-amber-500 rounded-full"></span>
          )}
        </div>
        <button
          type="button"
          onClick={() => setShowFilters(!showFilters)}
          className="text-sm text-amber-600 font-medium"
        >
          {showFilters ? 'Hide' : 'Show'}
        </button>
      </div>

      <form 
        onSubmit={(e) => {
          e.preventDefault();
          onApply();
        }} 
        className={`flex flex-col lg:flex-row gap-3 ${!showFilters ? 'hidden md:flex' : ''}`}
      >
        <div className="flex-1">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-stone-400" />
            <input
              type="text"
              placeholder="Search rooms..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="w-full pl-9 pr-3 py-2.5 text-sm border border-stone-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent touch-manipulation"
            />
          </div>
        </div>

        <select
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
          className="px-3 py-2.5 text-sm border border-stone-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent touch-manipulation bg-white min-h-[42px]"
        >
          <option value="">All Status</option>
          <option value="available">Available</option>
          <option value="booked">Booked</option>
        </select>

        <select
          value={typeFilter}
          onChange={(e) => setTypeFilter(e.target.value)}
          className="px-3 py-2.5 text-sm border border-stone-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-500 focus:border-transparent touch-manipulation bg-white min-h-[42px]"
        >
          <option value="">All Types</option>
          {roomTypes.map((type) => (
            <option key={type} value={type}>{type}</option>
          ))}
        </select>

        <button
          type="submit"
          className="px-4 py-2 text-sm font-semibold text-white gold-gradient rounded-lg hover:opacity-90 transition-opacity whitespace-nowrap"
        >
          Apply Filters
        </button>
      </form>
    </div>
  );
}
